/*
* @Author: gujianghua
* @Date:   2018-08-08 19:49:45
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-03-23 16:35:27
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	//列表
	getDataList(page, params) {
	  return service({
	    url: '/cloud/uac/enterprise/pages?pageIndex=' + page.pageIndex + '&pageSize=' + page.pageSize,
	    method: 'post',
	    data: params
	  })
	},
	/**
	 * [switch 上下架]
	 * @param  {[obj]} params [id,status]
	 * @return {[obj]}
	 */
	switch(params) {
	  return service({
	    url: '/cloud/uac/enterprise/status',
	    method: 'post',
	    data: params
	  })
	},
	/**
	 * [remove 删除]
	 * @param  string params id
	 * @return {[obj]}
	 */
	remove(id) {
	  return service({
      url: `/cloud/uac/enterprise/del/${id}`,
	    method: 'get'
	  })
	},
	/**
	 * [create 创建数据]
	 * @param  {[obj]} data [表单数据]
	 * @return {[obj]}
	 */
	create(data) {
		return service({
		    url: '/cloud/uac/enterprise/baseSave',
		    method: 'post',
		    data: data
		})
	},
	//同上
	update(data) {
		return service({
		    url: '/cloud/uac/enterprise/baseSave',
		    method: 'post',
		    data: data
		})
	},
  	/**
  	 * [cityExchange 根据code列表获取对应的名称]
  	 * @param  {[obj]} params [ityCode的字符串 英文逗号分隔]
  	 * @return {[obj]}
  	 */
  	cityExchange(params) {
	  	return service({
		    url: '/cloud/uac/distract/city/list',
		    method: 'post',
		    params: params
	  	})
  	},

  getData(id) {
    return service({
      url: `/cloud/uac/enterprise/detail/${id}`,
      method: 'get'
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/operateManage/enterprise.js